import React from "react";

class App extends React.Component {
    render() {
        return (
            <div style={{maxWidth: "100vw", height: "100vh", display: "flex"}}>
                <img
                    src={require("../static/bigImg.jpg")}
                    alt=""
                    style={{maxWidth: "100%", display: "block", margin: "auto"}}
                />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/BigImg.js